import SHOPPING_CART_CONSTANTS from "../constants/shoppingCart-constants";

export interface ShoppingCartReducerState {
    cartItems: any[];
    isProductDeleted: boolean;
    isProductAdded: boolean;
    isProductInCart: boolean;
}

const initialState: ShoppingCartReducerState = {
    cartItems : [],
    isProductDeleted: false,
    isProductAdded: false,
    isProductInCart: false
}

export const shoppingCartReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SHOPPING_CART_CONSTANTS.CART_ADD_ITEM:
            let item = action.payload;
            let itemExists: any = state.cartItems.find((cartItem: any) => cartItem.id === item.id);

            if (itemExists) {
                return {
                    ...state,
                    isProductInCart: true,
                    isProductAdded: false,
                    isProductDeleted: false,
                    cartItems: state.cartItems.map((cartItem: any) => cartItem.id === itemExists.id
                        ? item : cartItem)
                };
            } else {
                return {
                    ...state,
                    isProductInCart: false,
                    isProductAdded: true,
                    isProductDeleted: false,
                    cartItems: [...state.cartItems, item]
                };
            }

        case SHOPPING_CART_CONSTANTS.CART_REMOVE_ITEM:
            return {
                ...state,
                isProductDeleted: true,
                isProductAdded: false,
                cartItems: state.cartItems.filter((cartItem: any) => cartItem.id !== action.payload)
            };
        
        case SHOPPING_CART_CONSTANTS.CART_UPDATE_QTY:
            let itemToUpdateQTY = action.payload;
            let itemInCart: any = state.cartItems.find((cartItem: any) => cartItem.id === itemToUpdateQTY.id);

            return {
                ...state,
                cartItems: state.cartItems.map((cartItem: any) => cartItem.id === itemInCart.id
                    ? itemToUpdateQTY : cartItem)
            };
        
        case SHOPPING_CART_CONSTANTS.CART_RESET_MESSAGE:
            return {
                cartItems: [...state.cartItems],
                isProductDeleted: false,
                isProductAdded: false,
                isProductInCart: false
            };
        
        case SHOPPING_CART_CONSTANTS.CART_RESET:
            return {
                cartItems: [],
                isProductDeleted: false,
                isProductAdded: false,
                isProductInCart: false
            };
    
        default:
            return state;
    }
}